export const IconPrev = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    fill="none"
    viewBox="0 0 16 18"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m5.508 9 6.58-6.579L10.579.912 2.491 9l8.088 8.088 1.508-1.509z"
      clipRule="evenodd"
    />
  </svg>
);
